export { GoToTopButton } from './go-to-top-button';
